const OnLeaveIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="4" fill="#F2FFF9" />
      <path
        d="M7.25049 22.25H24.7505M8.50049 19.75H23.5005M21.6255 13.5V19.75M17.8755 13.5V19.75M14.1255 13.5V19.75M10.3755 13.5V19.75M7.87545 13.5H24.1255L16.0005 8.5L7.87545 13.5Z"
        stroke="#11A75C"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default OnLeaveIcon;
